import CreateTemplateAccessSettings from './CreateTemplateAccessSettings';
import CreateTemplateBasicInfo from './CreateTemplateBasicInfo';
import { useCreateTemplateState } from './CreateTemplateContext';
import CreateTemplateDestination from './CreateTemplateDestination';
import CreateTemplateSource from './CreateTemplateSource';
import { useTranslation } from 'react-i18next';

const CreateTemplateBody = () => {
  const { t } = useTranslation('Templates');
  const { form } = useCreateTemplateState();
  const { isCopyMode } = form;

  return (
    <div className="space-y-6">
      <CreateTemplateBasicInfo />
      <div className={isCopyMode ? 'grid gap-6 xl:grid-cols-2' : 'grid gap-6'}>
        <CreateTemplateSource />
        <div className="min-w-0 rounded-xl border border-slate-200/70 bg-white p-4 shadow-xs">
          <CreateTemplateDestination />
          <div className="mb-3 text-sm font-semibold text-slate-700">
            {t('createTemplateBody.accessSettingsHeading')}
          </div>
          <CreateTemplateAccessSettings />
        </div>
      </div>
    </div>
  );
};

export default CreateTemplateBody;
